"use strict";

// Field validation
export function is_numeric(evt) {
    const key_code = evt.which;
    let is_digit = (key_code >= 48 && key_code <= 57);
    // Firefox/Windows return 0 for non-pinting characters. Juss pass them.
    const is_nav_key = (key_code === 9 || key_code === 8 || key_code === 0);
    if (key_code === 46) {
        const field_contents = $(evt.target).val();
        const dot_index = field_contents.indexOf('.');
        is_digit = (dot_index === -1);
    }
    //    $("#key_code").text( key_code);
    return is_digit || is_nav_key;
}

global.is_numeric = is_numeric;

export function data_is_numeric(data) {
    let is_numeric = false;
    if (data !== null) {
        const intValue = parseInt(data, 10);
        if (!isNaN(intValue)) {
            is_numeric = true;
        }
    }
    return is_numeric;
}

export function strip_to_digits(input_string) {
    let digits_string = '';
    for (let i = 0; i < input_string.length; i++) {
        const current_character = input_string.substring(i, i + 1);
        const current_character_digit = parseInt(current_character, 10);
        if (!isNaN(current_character_digit)) {
            digits_string += current_character;
        }
    }
    return digits_string;
}

// Dates
// Pass two moments. Returns an object with the difference in years, months and days.
// Requires momnent.js library.
export function moment_difference(start_date, stop_date) {
    const cloned_start_date = moment(start_date);
    const date_difference = {};
    date_difference.years = stop_date.diff(cloned_start_date, 'years');
    cloned_start_date.add('years', date_difference.years);
    date_difference.months = stop_date.diff(cloned_start_date, 'months');
    cloned_start_date.add('months', date_difference.months);
    date_difference.days = stop_date.diff(cloned_start_date, 'days');
    cloned_start_date.add('days', date_difference.days);
    return date_difference;
}

//
// Simplified for speed -using moment.js "endOf()" incurs overhead.
// 0 indexed months
//
export function days_in_month_and_year(month, year) {
    let days_in_month = 0;
    switch (month) {
        case 0:
        case 2:
        case 4:
        case 6:
        case 7:
        case 9:
        case 11: {
            days_in_month = 31;
            break;
        }
        case 3:
        case 5:
        case 8:
        case 10: {
            days_in_month = 30;
            break;
        }
        case 1: {
            if (year % 4 === 0) {
                if (year % 100 === 0 && year % 400 !== 0) {
                    days_in_month = 28;
                } else {
                    days_in_month = 29;
                }
            } else {
                days_in_month = 28;
            }
            break;
        }
    }
    return days_in_month;
}

// Math
export function between(value, min, max) {
    return (value >= min && value <= max);
}

export function constrain(value, min, max) {
    return Math.max(min, Math.min(max, value));
}

export function roundf(value, significant_digits) {
    significant_digits = significant_digits || 0;
    return Math.round(value * Math.pow(10, significant_digits)) / Math.pow(10, significant_digits);
}

export function floorf(value, significant_digits) {
    significant_digits = significant_digits || 0;
    return Math.floor(value * Math.pow(10, significant_digits)) / Math.pow(10, significant_digits);
}

export function ceilf(value, significant_digits) {
    significant_digits = significant_digits || 0;
    return Math.ceil(value * Math.pow(10, significant_digits)) / Math.pow(10, significant_digits);
}

export function isset(value) {
    return value !== undefined && value !== null;
}

// css
export function loadCSS(href) {
    const cssLink = $('<link>');
    $('head').append(cssLink); // IE hack: append before setting href
    cssLink.attr({
        rel: 'stylesheet',
        type: 'text/css',
        href
    });
}

// Drawing
export function clear_svg(svg) {
    while (svg.lastChild) {
        svg.removeChild(svg.lastChild);
    }
}

export function Point(x, y) {
    this.x = x;
    this.y = y;
}

export function Rectangle(x, y, width, height) {
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
}

// Strings
export function pad(number, size) {
    // TODO: Handle negative numbers.
    let s = number + '';
    while (s.length < size) {
        s = '0' + s;
    }
    return s;
}

// Paths
export function scriptPath(script_name) {
    const scripts = document.getElementsByTagName('SCRIPT');
    let path = '';
    if (scripts && scripts.length > 0) {
        for (const script of scripts) {
            const match_exp = new RegExp(script_name);
            if (script.src && script.src.match(match_exp)) {
                path = script.src.replace(match_exp, '');
                break;
            }
        }
    }
    return path;
}

// Network
export function is_private_network(ip) {
    let private_network = false;
    if (ip.substring(0, 7) === '192.168') {
        private_network = true;
    } else if (ip.substring(0, 3) === '10.') {
        private_network = true;
    }
    return private_network;
}

// Touchscreen detection.
export function supports_touch() {
    return ('undefined' != typeof document.documentElement.ontouchstart);
}

// Element enable.
export function disableSelect(el) {
    if (el.addEventListener) {
        el.addEventListener('mousedown', disabler, 'false');
    } else if (el.attachEvent) {
        el.attachEvent('onselectstart', disabler);
    }
}

export function enableSelect(el) {
    if (el.removeEventListener) {
        el.removeEventListener('mousedown', disabler, 'false');
    } else if (el.detachEvent) {
        el.detachEvent('onselectstart', disabler);
    }
}

export function disabler(e) {
    if (e.preventDefault) {
        e.preventDefault();
    }
    return false;
}

// DOM
export function remove_all_children(element) {
    if (element !== undefined) {
        while (element.lastChild) {
            element.removeChild(element.lastChild);
        }
    }
}

// Errors
export function php_error(jqXHR, textStatus, errorThrown) {
    const error_window = window.open();
    error_window.document.write(jqXHR.responseText);
    // console.log( jqXHR );
}
